import { CheckCircle2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import type { MissingItem } from "./answerValidation";
import { Button } from "@/components/ui/button";

export function ReviewPanel({
  missing,
  onJump,
  onSubmit,
  submitting,
}: {
  missing: MissingItem[];
  onJump: (item: MissingItem) => void;
  onSubmit: () => void;
  submitting: boolean;
}) {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="review-title" className="flex flex-col gap-6">
      <div>
        <h2 id="review-title">{t("questionnaire.reviewTitle")}</h2>
        <p className="mt-1 text-fg-muted">{t("questionnaire.reviewIntro")}</p>
      </div>
      {missing.length > 0 ? (
        <div className="rounded-lg border border-border bg-surface-muted p-5">
          <h3 className="mb-3 text-lg">{t("questionnaire.missingTitle")}</h3>
          <ul className="flex flex-col gap-2">
            {missing.map((m) => (
              <li key={m.questionId}>
                <button
                  type="button"
                  onClick={() => onJump(m)}
                  className="min-h-11 text-left font-medium text-heading underline underline-offset-4 hover:text-secondary-hover"
                >
                  {m.title}
                </button>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p className="flex items-center gap-2 text-heading">
          <CheckCircle2 aria-hidden="true" className="h-5 w-5" />
          {t("questionnaire.reviewAllDone")}
        </p>
      )}
      <div className="flex flex-col items-start gap-2">
        <Button onClick={onSubmit} disabled={missing.length > 0 || submitting} aria-describedby={missing.length > 0 ? "submit-help" : undefined}>
          {submitting ? t("questionnaire.submitting") : t("questionnaire.submit")}
        </Button>
        {missing.length > 0 ? (
          <p id="submit-help" className="text-sm text-fg-muted">
            {t("questionnaire.missingHelp", { count: missing.length })}
          </p>
        ) : null}
      </div>
    </section>
  );
}
